module.exports = __webpack_public_path__ + "img/93aec1f246ac943ad85673713e1eb927.38a1e39b.jpg";